import { base_url, tenls_url, tenls_region, ux_plugin_url, env, regionToTenLSMapping, signup_environment, usage_types_url, phonebooks_url } from '../config/apiConfig';
import * as _ from 'lodash';
// This allows mocking in unit tests
import * as thisModule from "./FetchService";
import { forceRefreshAccessToken, getAccessToken, getTokenDiagnostics } from "../auth/authService";

export const fetchFeatureFlags = () => {
    if (base_url === '') {
        return Promise.resolve({ status: 404, json: () => Promise.resolve() })
    }
    return fetch(`${base_url}/featureFlags`,
        {
            method: 'GET',
            headers: {'Content-Type': 'application/json'}
        });
};

export const fetchTenlsFeatureFlags = (token) => {
    if (tenls_url === '') {
        return Promise.resolve({ status: 404, json: () => Promise.resolve() })
    }
    return fetch(`${_.replace(tenls_url, '%s', tenls_region)}/featureFlags?token=${token}`,
        {
            method: 'GET',
            headers: {'Content-Type': 'application/json'}
        });
};

export const fetchOrders = (token, call2Tenls) => {
    const fetchURL = `${call2Tenls ? _.replace(tenls_url, '%s', tenls_region) : base_url}/orders?token=${token}`;
    return fetch(
        fetchURL,
        {
          method: 'GET',
        headers: {'Content-Type': 'application/json'}
        }
    );
};
export const fetchUsageTypes = async () => {
    await getTokenDiagnostics();
    const fetchURL = usage_types_url;

    const parseJwtPayload = (jwtToken) => {
        try {
            const payload = jwtToken?.split('.')?.[1];
            if (!payload) {
                return null;
            }
            const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
            const decoded = atob(normalized.padEnd(normalized.length + (4 - (normalized.length % 4 || 4)) % 4, '='));
            return JSON.parse(decoded);
        } catch {
            return null;
        }
    };


    const executeFetchWithBearer = async (accessToken) => fetch(fetchURL, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    });

    const isAuthHtmlResponse = (response) => {
        const contentType = (response.headers.get('content-type') || '').toLowerCase();
        const location = (response.headers.get('location') || '').toLowerCase();
        const redirectedToLogin = (response.url || '').toLowerCase().includes('login') || location.includes('login');
        return response.status === 401 || response.status === 403 || contentType.includes('text/html') || redirectedToLogin;
    };

    let token = await getAccessToken();
    if (!token) throw new Error("Not authenticated");

    let response = await executeFetchWithBearer(token);
    if (!isAuthHtmlResponse(response)) {
        return response;
    }

    token = await forceRefreshAccessToken();
    if (!token) {
        throw new Error('Session expired. Please sign in again.');
    }

    response = await executeFetchWithBearer(token);
    if (isAuthHtmlResponse(response)) {
        const claims = parseJwtPayload(token);

        const audience = Array.isArray(claims?.aud) ? claims.aud.join(',') : (claims?.aud || 'unknown');
        const scope = claims?.scope || claims?.scp || 'unknown';
        throw new Error(
            `Authenticated request returned auth challenge for ${fetchURL}. ` +
            `Verify IDCS app grants API audience/scope for this endpoint. token_aud=${audience}; token_scope=${scope}`
        );
    }

    return response;
};

export const fetchPhonebooks = async () => {
    const fetchURL = phonebooks_url;

    const executeFetchWithBearer = async (accessToken) => fetch(fetchURL, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    });

    const isAuthHtmlResponse = (response) => {
        const contentType = (response.headers.get('content-type') || '').toLowerCase();
        const location = (response.headers.get('location') || '').toLowerCase();
        const redirectedToLogin = (response.url || '').toLowerCase().includes('login') || location.includes('login');
        return response.status === 401 || response.status === 403 || contentType.includes('text/html') || redirectedToLogin;
    };

    let token = await getAccessToken();
    if (!token) throw new Error("Not authenticated");

    let response = await executeFetchWithBearer(token);
    if (!isAuthHtmlResponse(response)) {
        return response;
    }

    token = await forceRefreshAccessToken();
    if (!token) {
        throw new Error('Session expired. Please sign in again.');
    }

    response = await executeFetchWithBearer(token);
    if (isAuthHtmlResponse(response)) {
        throw new Error(
            `Authenticated request returned auth challenge for ${fetchURL}. ` +
            `Verify IDCS app grants API audience/scope for this endpoint.`
        );
    }

    return response;
};

export const fetchAccountNameValidation = (nameAttempt, call2tenls = false, domainType = {}, validationURL) => {
    //Get JWT toke from url query
    const token = new URLSearchParams(window.location.search).get('activationToken');
    const decoded = thisModule.jwt2Obj(token);
    const lHeaders = _.get(decoded, 'version', '') === 'V2' && call2tenls === false
        ? {'Content-Type': 'application/json', 'api-flow': 'PLC'}
        : {'Content-Type': 'application/json'};
    const tenlsURL = validationURL !== '' ? validationURL : _.replace(tenls_url, '%s', tenls_region);
    const fetchURL = call2tenls ? `${tenlsURL}/accounts?token=${token}&cloudAccount=${nameAttempt}` : `${base_url}/validateAccountName`;
    const body = domainType && domainType.value && domainType.value === 'LIGHT_WEIGHT_DOMAIN' ? JSON.stringify({ name: nameAttempt, domainType: domainType.value, token: token }) : JSON.stringify({name: nameAttempt, token: token});
    return fetch(
        fetchURL,
        {
            method: call2tenls ? 'GET':'POST',
            headers: lHeaders,
            body: call2tenls ? null : body
        }
    );
};

export const fetchBanner = () => {
  return fetch(
    `${base_url}/banner`,
    {
      method: 'GET',
      headers: {'Content-Type': 'application/json'}
    }
  );
};

export const fetchRegions = (path, call2tenls, publicOffer = false) => {
    const clientIdParam = path.includes('?') && path.includes('=') ? `&clientId=ActivateUI` : '?clientId=ActivateUI';
    const token = new URLSearchParams(window.location.search).get('activationToken');
    const envParam = publicOffer && ['uat', 'uat2'].includes(env) ? `&environment=${signup_environment.toLocaleLowerCase()}`: '';
    const fetchURL = `${call2tenls ? _.replace(tenls_url, '%s', tenls_region) : base_url}${path}${clientIdParam}${envParam}${'&token=' + token}`;
    return fetch(
        fetchURL,
        {
            method: 'GET',
            headers: {'Content-Type': 'application/json'}
    });
};

export const fetchPutCreateTenancy = (token, id, homeRegion) => {
    const fetchURL = `${_.replace(tenls_url, '%s', tenls_region)}/orders?token=${token}`;
    const body = JSON.stringify({id, homeRegion, token});
    return fetch(
        fetchURL,
    {
            method: 'PUT',
            headers: {'Content-Type': 'application/json'},
            body: body
    });
}

export const fetchCreateTenancy = (token, body, call2tenls, homeRegion, publicOffer = false, validateTenancyURL) => {
    const decoded = thisModule.jwt2Obj(token);
    const version = _.get(decoded, 'version', '');
    const lHeaders = version === 'V2' && call2tenls === false
                ? {'Content-Type': 'application/json', 'api-flow': 'PLC'}
                : {'Content-Type': 'application/json'};
    const envParam = publicOffer && ['uat', 'uat2'].includes(env) ? `environment=${signup_environment.toLocaleLowerCase()}&`: '';
    const fetchURL = `${call2tenls ? getTenLSEndpoint(homeRegion, validateTenancyURL) : base_url}/tenancies?${envParam}token=${token}`

  return fetch(
    fetchURL,
    {
      method: 'POST',
      headers: lHeaders,
      body: body
    }
  );
};

export const fetchAsset = (path) => {
    return fetch(
        `${ux_plugin_url}${path}`,
        { method: 'GET' }
    );
};

export const fetchStateId = (country) => fetch(
    `${base_url}/states?countryId=${country}`,
    {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    },
);

export const jwt2Obj = (token) => {
    let result;
    try {
        result = JSON.parse(Buffer.from(_.split(token, '.')[1], 'base64').toString());
    } catch {
        result = null;
    }
    return result;
};

export const getFeatureFlag = (featureName, featureFlags) => {
    if (!_.isEmpty(featureFlags)) {
        const index = _.findIndex(featureFlags, (o) => o.featureName === featureName);
        return index >= 0 ? featureFlags[index].isActive : false;
    }

    return false;
};

/**
 * Returns the appropriate Tenls Endpoint
 * 
 * @param {string} homeRegion - home region id (e.g., "us-ashburn-1").
 * @param {string} validateTenancyURL - Pre formatted constructed from domain attribute received form regions api (after selection of regions)
 * @returns {string} The resolved endpoint
 *
 * In r1, oc1 we need use the domain attribute from regions api
 * In all other environments, the endpoint is constructed using the homeRegion id.
 */
export const getTenLSEndpoint = (homeRegion, validateTenancyURL) => {
    if (['dev', 'uat', 'uat2', 'prd'].includes(env)) {
        return validateTenancyURL;
    }
    return _.replace(tenls_url, '%s', homeRegion);
}

export const isInAllowedListedTokens = (token) => {
    const list = [];
    return list.includes(token);
}
